module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-forklift-maintenance/master-forklift-maintenance.component.scss
// module id = ./src/app/master/master-forklift-maintenance/master-forklift-maintenance.component.scss
// module chunks = main